import { PALETTE as P } from '@app/util/colors';

export const lineColor = P.OV_10;
export const labelsColor = P.Grey40;
export const axisTitleColor = P.Grey30;
